import Location from 'react-app-location';

export const LoginLocation = new Location('/login');
